import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
    import { importCarDataRow, readCarImportFile } from '@/api/ErpCars';
    import { toBase64 } from '@/utils/files';
    import { DataParseResult } from '@/interfaces/cars/DataParseResult';
    import emitter from '@/utils/mitt';
    import { alertError, alertInfo, confirm } from '@/utils/dialogs';
    import { DataImportError } from '@/interfaces/cars/DataImportError';
    import { useRouter } from 'vue-router/composables';
    // @ts-ignore
    import LottieAnimation from 'lottie-web-vue';
    import loadingAnimation from '@/assets/animations/loading.json';
    import auth from '@/store/auth/auth';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CarImport',
  setup(__props) {

    const file = ref<File>();
    const parseResult = ref<DataParseResult>();
    const importErrors = ref<DataImportError[]>([]);
    const importCounter = ref<number>(0);
    const router = useRouter();

    const error_columns = [
        {
            field: 'row',
            label: 'Zeile',
            numeric: true,
        },
        {
            field: 'column',
            label: 'Spalte',
        },
        {
            field: 'msg',
            label: 'Fehlermeldung',
        },
    ];

    const newCars = computed<number>(() => {
        if (!parseResult.value?.data) {
            return 0;
        }

        return parseResult.value?.data.filter((car) => !car.id).length;
    });

    async function doImport() {
        const { result, dialog } = await confirm(
            'Auto-Import durchführen',
            'Soll der Import wirklich durchgeführt werden?',
            'Importieren',
        );

        if (result) {
            // 'OK' clicked, closing dialog
            dialog.close();

            if (!parseResult.value || !parseResult.value.data) {
                throw new Error('parse result is undefined');
            }

            for (const row of parseResult.value.data) {
                let response;
                response = await importCarDataRow(row);
                importCounter.value += 1;

                if (response && (response.status === 401 || response.status === 422)) {
                    await auth.dispatchRefreshToken();

                    response = await importCarDataRow(row);
                }

                if (!response.parsedBody) {
                    alertError('Error', 'Unbekannter Fehler, bitte Dev-Team kontaktieren.');
                    throw new Error('Error while processing import');
                }

                if (!response.parsedBody.success && response.parsedBody.error) {
                    importErrors.value?.push(response.parsedBody.error);
                }
            }

            const successCounter = parseResult.value?.data.length - importErrors.value.length;

            alertInfo('Info', `${successCounter} Zeilen wurden erfolgreich importiert.`);
        }
    }

    async function onFileAdded() {
        // reset import stuff
        importCounter.value = 0;
        importErrors.value = [];
        emitter.emit('showLoader');

        if (!file.value) {
            throw new Error('File is undefined');
        }

        let response;
        const importData = {
            data: await toBase64(file.value, true),
            filename: file.value.name,
        };

        response = await readCarImportFile(importData);

        if (response && (response.status === 401 || response.status === 422)) {
            await auth.dispatchRefreshToken();

            response = await readCarImportFile(importData);
        }

        if (!response.parsedBody) {
            throw new Error('Cannot read import file');
        }

        parseResult.value = response.parsedBody;
        emitter.emit('hideLoader');
    }

return { __sfc: true,file, parseResult, importErrors, importCounter, router, error_columns, newCars, doImport, onFileAdded, LottieAnimation, loadingAnimation }
}

})